const incompleteProductColumns = [
  {
    key: 'name',
    label: 'Name'
  },
  {
    key: 'stage',
    label: 'Stage'
  },
  {
    key: 'updated',
    label: 'Updated'
  },
  {
    key: 'actions',
    label: 'Actions'
  }
];

export default incompleteProductColumns;
